import { selectCurrentProjectTour } from '@/domain/project-tour/project-tour.selectors';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { dispatchTwiceGetImpactCalculateTour } from './utils/dispatch-twice-get-impact-calculate-tour';

type Params = {
  sequenceId: number;
};

type Result = void;

export const runImpactCalculateTourCo2ForSequence = createAppAsyncThunk(
  'impactCalculateTour/runImpactCalculateTourCo2ForSequence',
  async (
    params: Params,
    {
      extra: { impactCalculateTourGateway, snackbarGateway },
      dispatch,
      getState,
    },
  ): Promise<Result> => {
    try {
      await impactCalculateTourGateway.runImpactCalculateTourCo2ForSequence(
        params.sequenceId,
      );
      const currentProject = selectCurrentProjectTour(getState());
      if (currentProject) {
        dispatchTwiceGetImpactCalculateTour(dispatch, currentProject.id);
      }
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
